export default "__VITE_ASSET__HC4ftNoe__"